import moment from 'moment'
//export const TODAY_DATE_TIME = new Date().toISOString().replace(/T/, ' '). replace(/\..+/, '')     // delete the dot and everything after
export const CURRENT_DATE_TIME = () => moment().utcOffset("+05:30").format('YYYY-MM-DD HH:mm:ss')   // delete the dot and everything after

export const LENGTH_ERROR =(length)=>`Length should be less than ${length} characters`
export const MIN_LENGTH_ERROR =(text,length)=>`${text} must be at least ${length} characters`